module.exports = __webpack_public_path__ + "static/media/bg.2a855d05.png";